import * as Yup from 'yup'
import moment from 'moment'

const nameRegex = /[a-zA-z ']+$/
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
export const registrationSchema = Yup.object({
  title: Yup.string().required('Kindly select a title'),
  firstName: Yup.string()
    .required()
    .matches(nameRegex, 'Please enter a valid name')
    .min(3, 'First name must have at least 3 characters')
    .max(16, 'First name must have at most 26 characters'),
  lastName: Yup.string()
    .required()
    .matches(nameRegex, 'Please enter a valid name')
    .min(3, 'Last name must have at least 3 characters')
    .max(26, 'Last name must have at most 26 characters'),

  email: Yup.string().email().required().matches(emailRegex, 'Invalid Email'),
  bvn: Yup.string().min(11).max(11),
  nin: Yup.string().min(11).max(11),
  address: Yup.string().min(2).max(250),
  accountNumber: Yup.string()
    .min(10, 'Account Number must be 10 digits')
    .max(15),
  accountName: Yup.string()
    .min(3)
    .max(145)
    .test('accountName', 'Kindly enter a valid account detail', (value) => {
      if (
        value === "Account doesn't exist" ||
        value === 'Fetching Account Name'
      ) {
        return false
      }
      return true
    }),
  dateOfBirth: Yup.string()
    .required()
    .test('dateOfBirth', 'You must be older than 18years', (value, ctx) => {
      const parsedDate = moment(value)
      const age = moment().diff(parsedDate, 'years')
      if (age < 18) {
        return false
      }
      return true
    }),
  signatureName: Yup.string()
    // .required('You need to upload a signature')
    // .min(1, 'You need to upload a signature')
    .test('signatureName', 'You need to upload Signature', (value, ctx) => {
      if (!value) return false
      return true
    }),
  passportName: Yup.mixed()
    .nullable()
    // .required('You need to upload a Passport')
    // .min(1, 'You need to upload a Passport')
    .test('passportName', 'You need to upload a Passport', (value, ctx) => {
      if (!value) return false
      return true
    }),
  nok_firstName: Yup.string()
    .required('Kindly fill this field')
    .matches(nameRegex, 'Please enter a valid name')
    .test(
      'nok_firstName',
      'Next of kin firstname must be different from your name',
      (value, ctx) => {
        if (value === ctx.parent?.firstName) {
          return false
        }
        return true
      },
    ),
  // nok_mobile: Yup.string()
  //   .required()
  //   .test(
  //     'nok_mobile',
  //     'Next of kin mobile number must be different from your own',
  //     (value, ctx) => {
  //       //
  //       if (value === ctx.parent?.mobile) {
  //         return false
  //       }
  //       return true
  //     },
  //   ),
  nok_email: Yup.string()
    .required('Kindly Enter Next of Kin Email')
    .test(
      'nok_email',
      'Next of kin email must be different from your own',
      (value, ctx) => {
        //
        if (value === ctx.parent?.email) {
          return false
        }
        return true
      },
    ),
  amount: Yup.string()
    .required()
    .test(
      'amount',
      'Amount is below the expected minimum rate',
      (value, ctx) => {
        let product = Number(ctx?.parent?.productType) - 1
        product = product > 0 ? product : 0
        let productAmount =
          ctx.parent?.bidPrice?.[product]?.quantity *
          ctx.parent?.bidPrice?.[product]?.price
        if (Number(value) >= productAmount) {
          //
          return true
        }
        return false
      },
    ),
})
